import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=4ea1ed2c"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
import style0 from "./EmpresaForm.vue?vue&type=style&index=0&id=4ea1ed2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports